import { useState } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { CalendarMonth, TaskOutlined } from '@mui/icons-material';
import { useCRMFunction } from './useCRMFunction';

import moment from "moment";
moment.locale("es");

export const useCRMTask = (changeAlert: ChangeAlertCallbackType, pplTab?: string) => {
    const { onHandleGetTasks, onHandleCreateTasks, onHandleAddCommentTask, onHandleUpdateTask, onHandleDeleteTask } = useCRMFunction(changeAlert);

    const [data, setData] = useState({});
    const [filterTasks, setFilterTasks] = useState(null);
    const [editTask, setEditTask] = useState(null);
    const [loading, setLoading] = useState(false);
    
    const [showEditor, setShowEditor] = useState(false);
    const [tabActive, setTabActive] = useState("current");

	const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [totalDocuments, setTotalDocuments] = useState(0);

    const tabs = [
        { key: "current", type: 'meet', title: 'Programados' },
        { key: "history", type: 'meet', title: 'Pasados' },
        { key: "current", type: 'task', title: 'Todos' },
        { key: "to_do", type: 'task', title: 'Por hacer' },
        { key: "history", type: 'task', title: 'Completadas' },
    ];

    const screenType = [
        { key: 'task', title: 'Tareas de seguimiento', icon: <TaskOutlined sx={{ mr: 1 }}/> },
        { key: 'meet', title: 'Eventos', icon: <CalendarMonth sx={{ mr: 1 }}/> },
    ];

    let agent = localStorage.session ? JSON.parse(localStorage.session) : {};

    const getTasks = async (lead = data, type = tabActive, new_page = page, results = rowsPerPage) => {
        setLoading(true);
        const resp = await onHandleGetTasks(lead, data, type, new_page, results, pplTab);
        if(resp){
            !lead['comments'] && typeof lead !== "string" && setData(lead)
            setFilterTasks(resp.content || []);
            setTotalDocuments(resp.pagination['total_documents']);
        }
        setLoading(false);
    };

    const createTasks = async (newTask) => {
        setLoading(true);
        setFilterTasks([]);

        let resp = await onHandleCreateTasks(newTask);
        resp ? getTasks(newTask) : setLoading(false);
    };

    const addComment = async (comment) => {
        setLoading(true);
        setFilterTasks([]);
        let resp = await onHandleAddCommentTask(comment, editTask, agent);
        resp ? getTasks(data, tabActive, 1) && onCloseTextEditor() : setLoading(false);
    };

    const onUpdateTask = async (row, action) => {
        setLoading(true);
        let resp = await onHandleUpdateTask(row, action);
        resp ? delete row["uuid"] && getTasks(row, tabActive, 1) : setLoading(false);
    };

    const onDeleteTask = async (uuid) => {
        setLoading(true);
        let resp = await onHandleDeleteTask(uuid);
        resp ? getTasks(data, tabActive, 1) : setLoading(false);
    };

    const changeTab = (tab: string) => {
        setTabActive(tab);
        getTasks(data, tab);
    };
    const changePage = (action, page, rows= rowsPerPage) => {
		setPage(page+1);
        getTasks(data, tabActive, page+1, rows);
	};
	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		setRowsPerPage(JSON.parse(JSON.stringify(event.target.value)));
        changePage(null, 0, parseInt(event.target.value, 10));
	};

    const onOpenTextEditor = (task) => {
        setShowEditor(true);
        setEditTask(task);
    };
    const onCloseTextEditor = () => {
        setShowEditor(false);
        setEditTask(null);
    };

    return {
        data,
        filterTasks,
        tabActive,
        loading,
        tabs,
        showEditor,
        screenType,
        pagination: { page, rowsPerPage, totalDocuments},
        getTasks,
        changeTab,
        changePage,
        handleChangeRowsPerPage,
        addComment,
        onCloseTextEditor,
        onOpenTextEditor,
        onUpdateTask,
        createTasks,
        onDeleteTask
    };
};
